import axios from 'axios'
import Global from '@/global'

const apis = {
  uploadFile: '/api/storage/save',
  applyRole: '/hiapigw/app/conference/roles/add',
  confirmRole: '/hiapigw/app/conference/roles/confirm',
  stopConference: '/hiapigw/app/conference/stop',
  joinConference: '/hiapigw/app/conference/join',
  kickOutMember: '/hiapigw/app/conference/members/kickout',
  addRoles: '/hiapigw/app/conference/roles/add',
  deleteRoles: '/hiapigw/app/conference/roles/delete',
  transferRole: '/hiapigw/app/conference/roles/transfer'
}

// 上传文件
export function uploadFile (formData) {
  return axios.post(apis.uploadFile, formData, {
    headers: {
      'Content-Type': 'multipart/form-data;charset=UTF-8'
    },
    params: {
      _id: Global.genNonce(5)
    }
  }).then(res => {
    if (+res.data.retCode === 0) {
      return res.data.url
    }
  })
}

// 申请权限
export function applyRole (data) {
  return axios.post(apis.applyRole, data, {
    params: {
      _id: Global.genNonce(5)
    }
  })
}

// 授予或拒绝权限
export function confirmRole (data) {
  return axios.post(apis.confirmRole, data, {
    params: {
      _id: Global.genNonce(5)
    }
  })
}

// 关闭协作
export function stopConference (data) {
  return axios.post(apis.stopConference, data, {
    params: {
      _id: Global.genNonce(5)
    }
  })
}

// 加入协作
export function joinConference (data) {
  return axios.post(apis.joinConference, data, {
    params: {
      _id: Global.genNonce(5)
    }
  })
}

// 踢人
export function kickOutMember (data) {
  return axios.post(apis.kickOutMember, data, {
    params: {
      _id: Global.genNonce(5)
    }
  })
}

// 为成员增加角色
export function addRoles (data) {
  return axios.post(apis.addRoles, data, {
    params: {
      _id: Global.genNonce(5)
    }
  })
}

// 为成员删除角色
export function deleteRoles (data) {
  return axios.post(apis.deleteRoles, data, {
    params: {
      _id: Global.genNonce(5)
    }
  })
}

// 转移成员角色
export function transferRole (data) {
  return axios.post(apis.transferRole, data, {
    params: {
      _id: Global.genNonce(5)
    }
  })
}
